import { useCallback, useMemo, useState } from 'react';

import { FieldMapOptionsModal } from '@components/FieldMapOptionsModal';
import { MAP_LAYERS } from '@components/FieldMapOptionsModal/FieldMapOptionsModal';

export const useFieldMapOptionsModal = ({
  treatmentZones,
  hasTreatmentZone = false
}: {
  treatmentZones: { label: string; color: string }[];
  hasTreatmentZone: boolean;
}) => {
  const [selectedLayers, setSelectedLayers] = useState<string[]>([MAP_LAYERS.TRIAL_AREA, MAP_LAYERS.TREATMENT_ZONES]);

  const [open, setOpen] = useState<boolean>(false);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const displayModal = useCallback(() => {
    setOpen(prev => !prev);
  }, []);

  const display = useMemo(() => {
    if (!open) return null;

    return (
      <FieldMapOptionsModal
        selectedLayers={selectedLayers}
        treatmentZones={treatmentZones}
        onClose={onClose}
        onMapLayersChange={mapLayers => setSelectedLayers(mapLayers)}
        hasTreatmentZone={hasTreatmentZone}
      />
    );
  }, [open, selectedLayers, treatmentZones, hasTreatmentZone, onClose]);

  return { displayModal, selectedLayers, display };
};
